import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import UICloseButton from '../UIComponents/CloseButton';

interface OverlayProps {
  title?: string;
  children: React.ReactNode;
  closefunc: (viewable: boolean) => void;
}


function SideScreenOverlay({ title, children, closefunc }: OverlayProps){
    return (
        <> 
            <div className="fullscreen-overlay">
                <Container fluid className="">
                    <Row>
                        <Col md={{span:7 }} className="coverarea h-100">

                        </Col>

                        <Col md={{span:5, offset:7 }} className="brand-primary-color workablearea" >
                            <Row>
                                <Col md={{span: 2}}><UICloseButton closefunc={closefunc} /></Col>
                            </Row>
                            {children}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default SideScreenOverlay;